import React from "react";
import HomePageSeo from "../components/HomePageSeo";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import IntroSection from "../components/IntroSection";
import ServicesGridSection from "../components/ServicesGridSection";
import SpotlightsSection from "../components/SpotlightsSection";
import WhyHostsChooseSection from "../components/WhyHostsChooseSection";
import HowItWorksSection from "../components/HowItWorksSection";
import ServiceAreasSection from "../components/ServiceAreasSection";
import CateringMenuPreviewSection from "../components/CateringMenuPreviewSection";
import EventsWeCaterSection from "../components/EventsWeCaterSection";
import ReservationSection from "../components/ReservationSection";
import TestimonialSection from "../components/TestimonialSection";
import FaqSection from "../components/FaqSection";
import FinalCtaSection from "../components/FinalCtaSection";
import Footer from "../components/Footer";
import FloatingCta from "../components/FloatingCta";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#051109] text-white selection:bg-[#E8A040] selection:text-[#051109]">
      {/* 1. SEO & Structured Data (JSON-LD Organization + FAQPage) */}
      <HomePageSeo />

      {/* 2. Top Navigation */}
      <Header />

      <main>
        {/* 3. Hero Section */}
        <HeroSection />

        {/* 4. Why Choose Nawabi Caterers When You Search for a Catering Service Near You */}
        <IntroSection />

        {/* 5. Our Catering Services (7 Services with exact docx CTAs) */}
        <ServicesGridSection />

        {/* 6. Feature Spotlights (Wedding, Non-Veg, Biryani Deep Dives) */}
        <SpotlightsSection />

        {/* 7. Why Hosts Choose Nawabi Caterers (7 Pillars) */}
        <WhyHostsChooseSection />

        {/* 8. How Our Catering Service Works (5-Step Numbered Process) */}
        <HowItWorksSection />

        {/* 9. We Serve Across - Tamil Nadu Wide Coverage (16 Cities) */}
        <ServiceAreasSection />

        {/* 10. A Look at Our Catering Menu (7 Categories + Live Counter Note) */}
        <CateringMenuPreviewSection />

        {/* 11. Events We Cater (8 Event Occasions + Crowd Note) */}
        <EventsWeCaterSection />

        {/* 12. Book Your Royal Feast enquiry form (Interactive Menu & Quote Builder) */}
        <ReservationSection />

        {/* 13. What Our Clients Say / In Our Clients Words (3 Reviews) */}
        <TestimonialSection />

        {/* 14. Frequently Asked Questions (All 10 FAQs) */}
        <FaqSection />

        {/* 15. Ready to Plan Your Event? Let's Talk Food. (Final Call To Action) */}
        <FinalCtaSection />
      </main>

      {/* 16. Footer */}
      <Footer />

      {/* 17. Floating Contact Pill (WhatsApp & Call) */}
      <FloatingCta />
    </div>
  );
};

export default HomePage;
